import React from "react";

import opacity from "hex-color-opacity";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import ColorDotWithLabel from "@src/sharedComponents/ColorDotWithLabel/ColorDotWithLabel";
import TooltipBasic from "@src/sharedComponents/Tooltip/TooltipBasic";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ProjectedReturnsGraph.module.css";

const ProjectedReturnsGraphHeading: React.FC = () => {
  const {
    color: { $chartSegmentOne },
  } = useTheme();

  return (
    <div className={styles.heading}>
      <div className={styles.flex}>
        <Text variant={"heading1"} color={"text"}>
          Projected Returns
        </Text>

        <TooltipBasic className={styles.tooltip} text={"Text..."} />
      </div>

      <div className={styles.flex}>
        <ColorDotWithLabel label={"Median"} color={$chartSegmentOne} />

        <ColorDotWithLabel
          className={styles.colorDotWithLabel2}
          label={"High and low"}
          color={opacity($chartSegmentOne, 0.2)}
        />
      </div>
    </div>
  );
};

export default ProjectedReturnsGraphHeading;
